import { render, staticRenderFns } from "./ShowNotification.vue?vue&type=template&id=53e2a3cb&scoped=true"
import script from "./ShowNotification.vue?vue&type=script&lang=js"
export * from "./ShowNotification.vue?vue&type=script&lang=js"
import style0 from "./ShowNotification.vue?vue&type=style&index=0&id=53e2a3cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e2a3cb",
  null
  
)

export default component.exports